import { FormContentContainer } from 'components/documentForm/styles'
import styled from 'styled-components'
import { Button as AntdButton } from 'antd'

export const AssitantContainer = styled(FormContentContainer)`
	height: 100%;
	flex-direction: column;
	padding: 1rem 1rem 2rem 1rem;
	justify-content: space-between;
`

export const InputContainer = styled.div`
	display: flex;
	gap: 0;
	height: 3.5rem;
	width: 100%;
`

export const Title = styled.div`
	background-color: #f2f4f8;
	display: flex;
	border-radius: 0.125rem;
	justify-content: space-between;
	align-items: center;
	padding: 0.75rem 1.25rem;

	& > div {
		display: flex;
		align-items: center;
		gap: 0.7rem;

		h3 {
			margin: 0;
		}
	}
`

export const Messages = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow-y: auto;
	margin-top: 1.25rem;
`

export const Message = styled.div`
	display: flex;
	padding: 0.5rem;

	& > img {
		width: auto;
		height: 3rem;
		margin-right: 0.5rem;
		margin-left: 0.5rem;
	}

	& > span {
		display: flex;
		flex-direction: column;
		flex-grow: 1;
		word-wrap: break-word;
		word-break: keep-all;
		border-radius: 0.125rem;
		padding: 0.5rem 1rem;
	}
`

export const UserMessage = styled(Message)`
	& > span {
		border: 2px solid #f2f4f8;
	}
`

export const AssistantMessage = styled(Message)`
	& > span {
		background-color: #f2f4f8;
		gap: 0.4rem;

		& > p {
			text-align: justify;
			width: 100%;
		}

		& > button {
			justify-content: start;
			align-items: start;
			height: auto;
		}
	}
`

export const TransparentButton = styled(AntdButton)`
	background: none;
	border: none;
	display: flex;
	align-items: center;
	justify-content: center;

	& > span {
		line-height: 0 !important;
	}
`

export const SendButton = styled(TransparentButton)`
	background-color: #002880;
	color: #fff;
	padding: 0rem 1.4rem;
	height: 100%;
`

export const SendContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
	width: 3.5rem;
`

export const CopyToCKEditorButton = styled.div`
	padding: 0;

	& > img {
		width: 1rem;
		height: 1rem;
		opacity: 0.3;
		cursor: pointer;
	}
`
